import { lazy } from 'react'

import { RouteErrorPage } from '../components/ErrorPage'
import { Loader } from '../components/Loader'
import {
  requestThreadMessageProfilePrintDataLoader,
  requestThreadMessageProfileRawDataLoader,
  requestThreadProfilePrintDataLoader,
} from '../components/RequestProfile'
import { ROUTE_PARAM_MAIL_UUID, ROUTE_PATH_LIST } from '../constants/route'
import { getUuidParamGuardLoader } from '../utils/route'

const EmailMessageProfileRaw = lazy(() =>
  import('../components/Email/EmailMessageProfileRaw').then(m => ({
    default: m.EmailMessageProfileRaw,
  }))
)
const EmailMessageProfilePrint = lazy(() =>
  import('../components/Email/EmailMessageProfilePrint').then(m => ({
    default: m.EmailMessageProfilePrint,
  }))
)
const EmailThreadProfilePrint = lazy(() =>
  import('../components/Email/EmailThreadProfilePrint').then(m => ({
    default: m.EmailThreadProfilePrint,
  }))
)

export function getRequestThreadRawRoutes() {
  return [
    {
      HydrateFallback: Loader,
      element: <EmailMessageProfileRaw />,
      errorElement: <RouteErrorPage />,
      loader: getUuidParamGuardLoader({
        loader: requestThreadMessageProfileRawDataLoader,
        paramName: ROUTE_PARAM_MAIL_UUID,
      }),
      path: `/${ROUTE_PATH_LIST.serviceRequestsThreads}/${ROUTE_PATH_LIST.mailMessageRaw}`,
    },
    {
      HydrateFallback: Loader,
      element: <EmailMessageProfilePrint />,
      errorElement: <RouteErrorPage />,
      loader: getUuidParamGuardLoader({
        loader: requestThreadMessageProfilePrintDataLoader,
        paramName: ROUTE_PARAM_MAIL_UUID,
      }),
      path: `/${ROUTE_PATH_LIST.serviceRequestsThreads}/${ROUTE_PATH_LIST.mailMessagePrint}`,
    },
    {
      HydrateFallback: Loader,
      element: <EmailThreadProfilePrint />,
      errorElement: <RouteErrorPage />,
      loader: getUuidParamGuardLoader({
        loader: requestThreadProfilePrintDataLoader,
        paramName: ROUTE_PARAM_MAIL_UUID,
      }),
      path: `/${ROUTE_PATH_LIST.serviceRequestsThreads}/${ROUTE_PATH_LIST.mailThreadPrint}`,
    },
  ]
}
